"use strict";

var _taggedTemplateLiteral = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
var _templateObject, _templateObject2;
Object.defineProperty(exports, "__esModule", {
  value: true
});
const codegen_1 = require("ajv/dist/compile/codegen");
const TYPES = ["undefined", "string", "number", "object", "function", "boolean", "symbol"];
function getDef() {
  return {
    keyword: "typeof",
    schemaType: ["string", "array"],
    code(cxt) {
      const {
        data,
        schema,
        schemaValue
      } = cxt;
      cxt.fail(typeof schema == "string" ? (0, codegen_1._)(_templateObject || (_templateObject = _taggedTemplateLiteral(["typeof ", " != ", ""])), data, schema) : (0, codegen_1._)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ".indexOf(typeof ", ") < 0"])), schemaValue, data));
    },
    metaSchema: {
      anyOf: [{
        type: "string",
        enum: TYPES
      }, {
        type: "array",
        items: {
          type: "string",
          enum: TYPES
        }
      }]
    }
  };
}
exports.default = getDef;
module.exports = getDef;